import React from "react";
import { colors, deviceHasHover } from "app/theme";
import Tooltip from "@mui/material/Tooltip";
import { useAuth0 } from "@auth0/auth0-react";
import Favourite from "@mui/icons-material/Favorite";
import FavouriteBorder from "@mui/icons-material/FavoriteBorder";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

interface BookmarkButtonProps extends IconButtonProps {
  iconSize?: string;
  iconColor?: string;
}

export const BookmarkIconButton: React.FC<BookmarkButtonProps> = (props) => {
  const { isAuthenticated } = useAuth0();
  const { iconColor = colors.text.body, iconSize = "20px", ...rest } = props;

  return (
    <Tooltip title={isAuthenticated ? "Bookmark" : "Login to bookmark"}>
      <IconButton
        aria-label="bookmark"
        sx={{
          svg: {
            width: iconSize,
            height: iconSize,
            ":first-of-type": {
              display: "block",
            },
            ":last-of-type": {
              display: "none",
            },
          },
          [deviceHasHover]: {
            ":hover": {
              svg: {
                ":first-of-type": {
                  display: "none",
                },
                ":last-of-type": {
                  display: "block",
                },
              },
            },
          },
          ...props.sx,
        }}
        {...rest}
      >
        <FavouriteBorder htmlColor={iconColor} />
        <Favourite htmlColor={iconColor} />
      </IconButton>
    </Tooltip>
  );
};

export const BookmarkCheckedIconButton: React.FC<BookmarkButtonProps> = (
  props
) => {
  const { iconColor = colors.text.body, iconSize = "20px", ...rest } = props;
  return (
    <IconButton
      aria-label="bookmark-checked"
      sx={{
        svg: {
          width: iconSize,
          height: iconSize,
          ":first-of-type": {
            display: "block",
          },
          ":last-of-type": {
            display: "none",
          },
        },
        [deviceHasHover]: {
          ":hover": {
            svg: {
              ":first-of-type": {
                display: "none",
              },
              ":last-of-type": {
                display: "block",
              },
            },
          },
        },
        ...props.sx,
      }}
      {...rest}
    >
      <Favourite htmlColor={iconColor} />
      <FavouriteBorder htmlColor={iconColor} />
    </IconButton>
  );
};
